import get from 'lodash/get';
import isPlainObject from 'lodash/isPlainObject';

export const compactObject = (data: Record<string, unknown>): Record<string, unknown> => {
  if (typeof data !== 'object') {
    return data;
  }

  return Object.keys(data).reduce(function (accumulator, key) {
    const isObject = typeof data[key] === 'object';
    const value = isObject ? compactObject(data[key]) : data[key];
    const isEmptyObject = isObject && !Object.keys(value).length;
    if (value === undefined || isEmptyObject) {
      return accumulator;
    }

    return Object.assign(accumulator, { [key]: value });
  }, {});
};

export function hasTruthyProperty<T extends object>(obj: T, path: string | Array<string | number>): boolean {
  const value = get(obj, path);

  if (value == null) return false;

  if (isPlainObject(value)) {
    return Object.values(value as Record<string, unknown>).some(Boolean);
  }

  return Boolean(value);
}
